exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gz-spinner{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/redirect/redirect.scss
// module id = 137
// module chunks = 0